module.exports = __webpack_public_path__ + "static/media/ad-separator.33a3a37d.png";